export enum jobsheetTatReportsActions {
  GET_JOBSHEETS_TAT_REPORTS_LOADING = "@@jobsheetTatReports/GET_JOBSHEETS_TAT_REPORTS_LOADING",
  GET_JOBSHEETS_TAT_REPORTS_SUCCESS = "@@jobsheetTatReports/GET_JOBSHEETS_TAT_REPORTS_SUCCESS",
  GET_JOBSHEETS_TAT_REPORTS_ERROR = "@@jobsheetTatReports/GET_JOBSHEETS_TAT_REPORTS_ERROR",
}